import * as colors from './colors';

const commonTheme = {
  disabled: colors.greyscale[600],
  error: colors.red,
  highlight: colors.green,
};

export const lightTheme = {
  ...commonTheme,
  accent: colors.lightBlue,
  background: colors.white,
  foreground: colors.darkBlue,
  input: colors.white,
  inputBorder: `1px solid ${colors.greyscale[600]}`,
  placeholder: colors.greyscale[600],
  tableRow: colors.greyscale[100],
  text: colors.greyscale[600],
};

export const darkTheme = {
  ...commonTheme,
  accent: colors.lightBlue,
  background: colors.darkBlue,
  foreground: colors.white,
  input: colors.fadedBlue,
  inputBorder: 'none',
  placeholder: colors.blueGrey,
  tableRow: colors.darkBlue,
  text: colors.white,
};
